import { useAuth } from "@dl/web-core-js/auth";
import { PageHeader } from "@dl/web-core-js/shell";
import { Badge, Card } from "@dl/web-core-js/ui";
import { useTranslation } from "react-i18next";

/**
 * Stands in for a screen that hasn't been ported yet.
 *
 * It is not decorative: it exercises the real route guard, so navigating to a
 * screen the account lacks the view code for shows the same "no access" state
 * the finished screen will.
 */
export function PlaceholderPage({ titleKey, view }: { titleKey: string; view: string }) {
  const { t } = useTranslation();
  const { hasView } = useAuth();

  if (view && !hasView(view)) {
    return (
      <>
        <PageHeader title={t("error.access-denied", "No access")} />
        <div className="p-4 lg:p-6">
          <Card className="p-6">
            <p className="text-[13px] text-ink-muted">
              {t("error.access-denied.detail", "Your account does not have permission to view this page.")}
            </p>
          </Card>
        </div>
      </>
    );
  }

  return (
    <>
      <PageHeader
        title={t(titleKey, titleKey)}
        badges={
          <Badge variant="info" size="sm">
            {t("common.not-ported", "Not ported yet")}
          </Badge>
        }
      />
      <div className="p-4 lg:p-6">
        <Card className="p-6">
          <p className="text-[13px] text-ink-muted">
            {t(
              "common.not-ported.detail",
              "This screen still runs in the Vaadin app. It lands here during the module port.",
            )}
          </p>
        </Card>
      </div>
    </>
  );
}
